import { FC, useMemo } from 'react';
import styled from 'styled-components';
import { ThemeProvider, useLegacyThemeServiceKey } from '../../../common/theme/ThemeProvider';
import Menu from '@splunk/react-ui/Menu';
import { AngularInjector } from '../../../common/AngularUtils';
import { PersistedMutingRule } from './mutingRule.model';
import ChevronRight from '@splunk/react-icons/ChevronRight';
import { variables } from '@splunk/themes';

const StyledDescriptionSpan = styled.span`
    display: inline-block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 238px;
    vertical-align: bottom;
`;

const StyledMenuItem = styled(Menu.Item)`
    display: flex;
    align-item: center;
    [data-test='label'] {
        display: flex;
        align-items: center;
        gap: ${variables.spacingSmall};
    }
`;

type DetectorMutingRuleMenuItemProps = {
    muting: PersistedMutingRule;
    handleMutingChange: (muting: PersistedMutingRule) => void;
};

export const DetectorMutingRuleItem: FC<DetectorMutingRuleMenuItemProps> = ({
    muting,
    handleMutingChange,
}) => {
    const themeKey = useLegacyThemeServiceKey();

    const mutingService = AngularInjector.useInjectedClass('mutingService');

    const formattedDuration = useMemo(
        () => mutingService.getFormattedDurationAndCreator(muting),
        [muting, mutingService]
    );

    return (
        <ThemeProvider colorScheme={themeKey}>
            <StyledMenuItem onClick={(): void => handleMutingChange(muting)}>
                <StyledDescriptionSpan>
                    {`${muting.description}${muting.description ? ' - ' : ''}${formattedDuration}`}
                </StyledDescriptionSpan>
                <ChevronRight />
            </StyledMenuItem>
        </ThemeProvider>
    );
};
